export const callNumber = (phoneNumber) => (dispatch, getState) => {
    window.location.href = `tel:${phoneNumber}`
}



// WEBPACK FOOTER //
// ./src/modules/sipgate/state/action.js